import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Intervals/editor/intervalseditor.tsx",
    () => import("./intervalseditor"),
);
